import { Navigate, Outlet } from 'react-router-dom';
import { FACILITY_ACCESS_DENIED_ROUTE_PATH } from '../routers/RoutPath';
import { useAuth } from '../pages/components/AuthContext';

interface RoleProtectedRouteProps {
  allowedRoles: string[];
  redirectPath?: string;
}

const RoleProtectedRoute = ({
  allowedRoles,
  redirectPath = FACILITY_ACCESS_DENIED_ROUTE_PATH,
}: RoleProtectedRouteProps) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user?.role) {
    return <Navigate to="/facility/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
